export interface StreakRecord {
  current: number
  longest: number
  lastDoneDate: string
  todayDone: boolean
  graceUsed: boolean
  totalActions: number
}

export interface RelationshipStreak {
  teacherId: string
  teacherName: string
  teacherColor: string
  count: number
  lastJoinDate: string
}

export interface UserStreakState {
  userId: string
  learning: StreakRecord
  completion: StreakRecord
  live: StreakRecord
  teaching: StreakRecord
  creation: StreakRecord
  relationships: Record<string, RelationshipStreak>
  streaks: {
    learning: StreakRecord
    completion: StreakRecord
    live: StreakRecord
    teaching: StreakRecord
    creation: StreakRecord
  }
}

const TODAY = new Date().toISOString().slice(0, 10)

const STUDENT_STREAKS = {
  learning: {
    current: 4,
    longest: 12,
    lastDoneDate: TODAY,
    todayDone: true,
    graceUsed: false,
    totalActions: 28,
  },
  completion: {
    current: 2,
    longest: 7,
    lastDoneDate: TODAY,
    todayDone: false,
    graceUsed: false,
    totalActions: 15,
  },
  live: {
    current: 1,
    longest: 5,
    lastDoneDate: TODAY,
    todayDone: false,
    graceUsed: false,
    totalActions: 9,
  },
  teaching: {
    current: 0,
    longest: 0,
    lastDoneDate: '',
    todayDone: false,
    graceUsed: false,
    totalActions: 0,
  },
  creation: {
    current: 0,
    longest: 0,
    lastDoneDate: '',
    todayDone: false,
    graceUsed: false,
    totalActions: 0,
  },
}

const DEMO_STUDENT: Omit<UserStreakState, 'userId'> = {
  ...STUDENT_STREAKS,
  relationships: {},
  streaks: STUDENT_STREAKS,
}

const TEACHER_STREAKS = {
  learning: {
    current: 0,
    longest: 0,
    lastDoneDate: '',
    todayDone: false,
    graceUsed: false,
    totalActions: 0,
  },
  completion: {
    current: 0,
    longest: 0,
    lastDoneDate: '',
    todayDone: false,
    graceUsed: false,
    totalActions: 0,
  },
  live: {
    current: 0,
    longest: 0,
    lastDoneDate: '',
    todayDone: false,
    graceUsed: false,
    totalActions: 0,
  },
  teaching: {
    current: 3,
    longest: 14,
    lastDoneDate: TODAY,
    todayDone: false,
    graceUsed: false,
    totalActions: 42,
  },
  creation: {
    current: 1,
    longest: 8,
    lastDoneDate: TODAY,
    todayDone: true,
    graceUsed: false,
    totalActions: 17,
  },
}

const DEMO_TEACHER: Omit<UserStreakState, 'userId'> = {
  ...TEACHER_STREAKS,
  relationships: {},
  streaks: TEACHER_STREAKS,
}

export function useStreak(role?: 'student' | 'teacher'): UserStreakState {
  const base = role === 'teacher' ? DEMO_TEACHER : DEMO_STUDENT
  return {userId: 'demo', ...base}
}
